(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  define('app/models/Song',['backbone', 'moment'], function(Backbone, moment) {
    'use strict';
    var Song;
    return Song = (function(_super) {
      __extends(Song, _super);

      function Song() {
        return Song.__super__.constructor.apply(this, arguments);
      }

      Song.prototype.parse = function(data) {
        data.created_at = moment(data.created_at);
        return data;
      };

      Song.prototype.currentSong = function() {
        if (!this.get('song')) {
          return;
        }
        return this.get('created_at').clone().add(this.get('song').duration, 'seconds') > moment();
      };

      Song.prototype.progressPercent = function() {
        var progress, song;
        if (!(song = this.get('song'))) {
          return;
        }
        progress = moment().diff(this.get('created_at'), 'seconds');
        return (progress / song.duration) * 100;
      };

      return Song;

    })(Backbone.Model);
  });

}).call(this);

//# sourceMappingURL=Song.js.map
;
